'use client'

import React from "react";
import { motion } from 'framer-motion';
import { Typography, Container, CardContent, Grid } from '@mui/material';
import Link from "next/link";

export const WerklisteSection = ({ data }) => {
    return (
        <motion.section
            className="section-large"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
        >
            <div className="section-header">
                <div className="section-title">
                    <Typography variant="h3" component="h1" gutterBottom>
                        Werkliste (Auszug)
                    </Typography>
                </div>
            </div>
            <div className="section-body">
                <Container maxWidth="full" className="no-padding">
                    {data && data.map((yearGroup, index) => (
                        <CardContent key={index} className="no-padding">
                            <Typography variant="h3" component="h2" gutterBottom>
                                {yearGroup.jahr}
                            </Typography>
                            <Grid container mb={2}>
                                {yearGroup.projects.map((project, idx) => (
                                    <Grid item xs={12} key={idx}>
                                        {project.projekt_id ? (
                                            <Typography variant="body1" color="text.primary" paragraph>
                                                <Link href={`/projekte/${encodeURIComponent(project.projekt_id)}`} key={idx}>
                                                    {project.titel}
                                                </Link>
                                            </Typography>
                                        ) : (
                                            <Typography variant="body1" color="text.primary" paragraph key={idx}>
                                                {project.titel}
                                            </Typography>
                                        )}
                                    </Grid>
                                ))}
                            </Grid>
                        </CardContent>
                    ))}
                </Container>
            </div>
        </motion.section>
    );
};
